import { api } from "@/lib/api";

export interface EmployeeTeam {
  id: string;
  parent_id: string;
  display_name: string;
  default_actor_for_tp_types: string[];
}

export function useEmployeeTeams() {
  return api.useQuery<EmployeeTeam[]>("datahub/employee-teams/");
}
